import './style/index.css';
import { BrowserRouter as Router ,Routes,Route} from 'react-router-dom';
import LoginPage from './pages/loginPage';
import DonationManagementPage from './pages/DonationManagementPage';
import ArticlePage from './pages/ArticlePage';
import HomePage from './pages/HomePage';
import PageNotFound from './pages/PageNotFound';
import SignUpPage from './pages/SignUpPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SideBar from './component/sideBar';
import ApplicationPage from './pages/ApplicationPage';
import PrivateRoute from './pages/PrivateRoute';
import { ToastContainer} from "react-toastify";
import UserContextProvider, { UserContext } from './context/userContext';
import { useContext, useEffect, useState } from 'react';
import ResetPage from './pages/ResetPassword';

import 'react-toastify/dist/ReactToastify.css';
import { RouteContext } from './context/routeContext';




function App() {
  const privateRoutes = ['/donation','/article','/fundApplication']
  
  const {activePage,} = useContext(RouteContext);

  return (
    <Router>
     <UserContextProvider>
     <ToastContainer/>
      <div className= {privateRoutes.includes(activePage)?'flex gap-2':'flex'}>
        {privateRoutes.includes(activePage)&&<SideBar/>}
        <Routes>
          <Route path='/' element={<LoginPage/> } />
          <Route path="/signup" element={<PrivateRoute />}>
          <Route path='/signup' element={<SignUpPage/>}/>
          </Route>

          <Route path='*' element={<PageNotFound/>} />
          <Route path='/resetPassword/:token/:id' element={<ResetPage/> } />

          {/* <Route path='/home' element={<HomePage/>} /> */}
          <Route path="/donation" element={<PrivateRoute />}>
              <Route path='/donation' element={<DonationManagementPage/>}/>
          </Route>
          <Route path="/article" element={<PrivateRoute />}>
              <Route path='/article' element={<ArticlePage/>} />
          </Route>
          <Route path="/fundApplication" element={<PrivateRoute />}>
              <Route path='/fundApplication' element={<ApplicationPage/>} />
          </Route>
          <Route path='/forgotpassword' element={<ForgotPasswordPage/>}/>
        </Routes>
      </div>  
      </UserContextProvider>
    </Router>
    
  );
}

export default App;
